<template>
  <div class="customer-components loader-container">
    <h2>Components</h2>
    <div class="actions loader-container">
      <input v-model="themeName" type="text" placeholder="e.g. Stark" /><button
        :disabled="!themeName"
        @click.prevent="addTheme"
      >
        Add Theme
      </button>
      <Loader :loading="addingTheme" />
    </div>
    <div class="table-wrapper loader-container">
      <vue-good-table
        :columns="[
          {
            label: 'Component',
            field: 'component.componentName'
          },
          {
            label: 'Server',
            field: 'server.serverName'
          }
        ]"
        :rows="customerComponents"
      ></vue-good-table>
      <Loader :loading="loadingCustomerComponents" />
    </div>
  </div>
</template>

<script>
import service from "@/services/service.js";
import Loader from "@/components/Loader.vue";
import { VueGoodTable } from "vue-good-table";
export default {
  components: { Loader, VueGoodTable },
  props: {
    customerId: { type: String, default: null }
  },
  data() {
    return {
      themeName: null,
      customerComponents: [],
      loadingCustomerComponents: false,
      addingTheme: false
    };
  },
  created() {
    this.getCustomerComponents();
  },
  methods: {
    addTheme() {
      var self = this;
      self.addingTheme = true;
      service
        .addTheme(self.customerId, self.themeName)
        .then(() => {
          self.themeName = null;
          self.addingTheme = false;
          self.getCustomerComponents();
        })
        .catch(() => {
          self.addingTheme = false;
        });
    },

    getCustomerComponents() {
      var self = this;
      self.loadingCustomerComponents = true;
      service
        .getComponents(self.customerId)
        .then(response => {
          self.customerComponents = response.data;
          self.loadingCustomerComponents = false;
        })
        .catch(() => {
          self.loadingCustomerComponents = false;
        });
    }
  }
};
</script>
